import React, { useContext, useEffect } from 'react';
import classNames from 'classnames';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Heading, Image, Col, Row } from '@thd-olt-component-react/core-ui';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { MulchCalculator as MulchCalculatorComponent } from '@thd-olt-component-react/calculator';
import { Metadata } from '@thd-olt-component-react/metadata';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { MulchCalculatorLinks } from './modules/MulchCalculatorLinks';
import '../../styles/mulch-calculator.scss';

const onCalculate = () => {
  LIFE_CYCLE_EVENT_BUS.trigger('project-calculator.calculate', { calculatorType: 'mulch' });
};

const crumbs = [
  {
    label: 'Home',
    url: '/'
  },
  {
    label: 'DIY Projects and Ideas',
    url: '/c/diy_projects_and_ideas'
  },
  {
    label: ' Project Calculators',
    url: '/c/project_calculators'
  },
  {
    label: 'Mulch and Top Soil Calculator',
    url: '/calculator/mulch'
  },
];

const metaDataProperties = {
  title: 'Mulch and Top Soil Calculator - The Home Depot',
  // eslint-disable-next-line max-len
  description: 'How much top soil and mulch do you need to meet your landscaping needs? Enter your preferred type of material, the square footage of the space to be covered and mulch depth for accurate results.',
  canonicalURL: '/calculator/mulch',
  type: 'Calculator',
  siteName: 'The Home Depot',
  fbAdmins: '100005416960152'
};

export const MulchCalculator = () => {
  const { channel } = useContext(ExperienceContext);

  const calculatorWrapperClasses = classNames(
    'mulch-calculator__wrapper', {
      'mulch-calculator__wrapper--mobile': channel === 'mobile'
    }
  );

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('project-calculator.page-load', { calculatorType: 'mulch' });
  }, []);

  return (
    <Row className="isBound mulch-calculator">
      <Row name="mulch-calculator__wrapper">
        <ErrorBoundary useContextForProps name="mulch-calculator-metadata">
          <Metadata data={metaDataProperties} />
        </ErrorBoundary>
        <ErrorBoundary name="mulch-calculator__content" className="mulch-calculator__content">
          <Col>
            <QueryProvider cacheKey="breadcrumbs">
              <Breadcrumbs
                className="mulch-calculator__breadcrumbs"
                staticCrumbs={crumbs}
              />
            </QueryProvider>
          </Col>
          <Col>
            <Heading
              className="mulch-calculator__heading"
              title="Mulch and Top Soil Calculator"
            />
          </Col>
          <div className="mulch-calculator">
            <Col fallback={12} xs={8}>
              <div className={calculatorWrapperClasses}>
                <Row>
                  <div className="mulch-calculator__banner-wrapper">
                    <Image
                      className="mulch-calculator__banner"
                      height={50}
                      width={50}
                      asset="mulch-calculator-banner.jpg"
                      alt="Calculator Banner"
                      lazy={false}
                    />
                  </div>
                  <div className="sui-w-full">
                    <QueryProvider cacheKey="calculator">
                      <MulchCalculatorComponent onCalculate={onCalculate} />
                    </QueryProvider>
                  </div>
                </Row>
              </div>
            </Col>
            <Col className="mulch-calculator__links" fallback={12} xs={4}>
              <MulchCalculatorLinks />
            </Col>
          </div>
        </ErrorBoundary>
      </Row>
    </Row>
  );
};

MulchCalculator.displayName = 'MulchCalculator';
